import React from 'react';
import {NavLink} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import SubnavOverflowTab from './SubnavOverflowTab';
import _ from 'lodash';

const EmployeeProfileSubnav = ({uiState}) => {
  const {history, visibleTabs, overflowTabs, overflowTabActive} = uiState;

  return (
    <ul className='Subnav-list list-reset'>
      {visibleTabs.map(tab => <li key={tab.path}>
        <NavLink to={tab.path} activeClassName='active'><FormattedMessage id={tab.text}/></NavLink>
      </li>)}
      {!_.isEmpty(overflowTabs) && <li>
        <SubnavOverflowTab
          links={overflowTabs.map((tab, index) => {
            return {
              order: index,
              text: tab.text,
              action: () => history.push(tab.path)
            };
          })}
          isActive={overflowTabActive}
        />
      </li>}
    </ul>
  );
};

export default EmployeeProfileSubnav;
